import { useMemo } from "react";
import { bindActionCreators } from "redux";
import { catalogActions } from ".";
import { useAppDispatch } from "../../app";

export const useCatalogActions = () => {
  const dispatch = useAppDispatch();
  return useMemo(() => bindActionCreators(catalogActions, dispatch), [dispatch]);
};
